import {
  ADJUNTOS_LAYER,
  CHACRAS_LAYER,
} from "./layers";

import {ActionButtonModel} from "../../../shared";

export const MAP_CRUD_WIDGETS: ActionButtonModel[] = [
  {
    title: CHACRAS_LAYER.title,
    canAdd: false,
  },
  {
    title: ADJUNTOS_LAYER.title,
    canAdd: false,
  }
];



